
<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="registrationForm">
      <div class="card mb-3">
        <div class="card-header"><h2>Event Details</h2></div>
        <div class="card-body">

          <div *ngIf="this.txtButton=='Update'" class="row mb-3">
            <div *ngIf="showButton" class="col-md-4">
              <label for="status">Type of Status<span class="text-danger">*</span></label>

              <ng-select [items]="filteredOptions"
                         bindLabel="label"
                         bindValue="value"
                         formControlName="status"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onStatusChange()" appendTo="body">
              </ng-select>

              <div *ngIf="f['status'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['status'].errors && f['status'].errors['required']">
                  type of status is required.
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <label for="eventOrganizedBy">Event Organization By<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="eventOrganizedBy" (change)="onSelectEventOrganizedChange($event)">
    <option value="">--Select--</option>
    <option *ngFor="let option of eventorganisedby" [value]="option.text">
      {{ option.text }}
    </option>
  </select>-->

              <ng-select [items]="eventorganisedby"
                         bindLabel="text"
                         bindValue="text"
                         formControlName="eventOrganizedBy"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onSelectEventOrganizedChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['eventOrganizedBy'].invalid && isSubmitted" class="alert alert-danger required">
                <small class="error">You must select an option.</small>
              </div>

            </div>
            <div class="col-md-6">
              <label for="implementationAgency">Implementation Agency</label>
              <input type="text" class="form-control" formControlName="implementationAgency" value={{implementationAgencyName}} placeholder="Enter implementation agency">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="usr">Event Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" autocomplete="off" formControlName="eventName" (blur)="onBlur('eventName')" placeholder="enter event" maxlength="500" />

              <!-- Validation error messages (keypress)="onKeyPress($event)" -->
              <div *ngIf="f['eventName'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['eventName'].errors?.['required']">
                  Event name is required.
                </div>
                <div *ngIf="f['eventName'].errors?.['maxlength']">
                  Event name cannot exceed 500 characters.
                </div>
                <div *ngIf="f['eventName'].errors?.['pattern']">
                  Event name must only contain letters, with a single space allowed between words.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="eventdate">Event Date-Time (DD/MM/YYYY)<span class="text-danger">*</span></label>
              <!--<input class="form-control" placeholder="dd/mm/yyyy hh:mm" type="datetime-local" formControlName="eventDateTime" [min]="minDate" [max]="maxDate" (blur)="onBlurReset()" />-->
              <!--<mat-form-field appearance="outline">-->
              <input class="form-control eventdate" matInput
                     placeholder="--select--"
         [matDatepicker]="startPicker"
         formControlName="eventDateTime"
         [value]="startDateTime | date: 'dd/MM/yyyy'"
                     (focus)="startPicker.open()"
         (dateChange)="onBlurReset()"
         [min]="minDate"
         [max]="maxDate"
         readonly />
       
              <mat-datepicker #startPicker></mat-datepicker>
              <!--</mat-form-field>-->
              <!-- Validation error messages -->
              <div *ngIf="f['eventDateTime'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['eventDateTime'].errors && f['eventDateTime'].errors['required']  && isSubmitted">
                  Event date is required.
                </div>
              </div>

            </div>


            
            <div class="col-md-3">
              <label for="eventTime">Select Time<span class="text-danger">*</span></label>
              <input class="form-control" placeholder="--select--" matInput [ngxMatTimepicker]="apicker" formControlName="eventStartTime" (blur)="resetTimeStatus()" (change)="onTimeChange($event)">
              <!--<input class="form-control" matInput [ngxMatTimepicker]="apicker" formControlName="eventStartTime" (change)="onTimeChange($event)" [min]="minTime">-->
              <ngx-mat-timepicker #apicker></ngx-mat-timepicker>

              <!-- Validation error messages -->
              <div *ngIf="f['eventStartTime'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['eventStartTime'].errors && f['eventStartTime'].errors['required']  && isSubmitted">
                  Event time is required.
                </div>
              </div>

            </div>


            <div class="col-md-3">
              <label for="durationEvent">Duration of Event<span class="text-danger">*</span></label>
              <input type="number" class="form-control" formControlName="durationEvent" placeholder="enter duration" min="1" max="8" (blur)="onBlurResetPeriod()" />

              <!-- Validation error messages -->
              <div *ngIf="f['durationEvent'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['durationEvent'].errors && f['durationEvent'].errors['required']">
                  Duration of event is required.
                </div>
                <div *ngIf="f['durationEvent'].errors?.['min']">
                  Duration of event must be at least 1 day/hour.
                </div>
                <div *ngIf="f['durationEvent'].errors?.['max']">
                  Duration of event cannot exceed 8 days/hours.
                </div>
              </div>

            </div>

          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="period">Period<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="period" (change)="onSelectPeriodChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of period" [value]="option.id">
      {{ option.text }}
    </option>
  </select>-->
              <ng-select [items]="period"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="period"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onSelectPeriodChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['period'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['period'].errors && f['period'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>


            <div class="col-md-3">
              <label for="distric">District<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="distric" (change)="onSelectDistricChange($event,'select')">
    <option value="">--select--</option>
    <option *ngFor="let option of district" [value]="option.id">
      {{ option.text }}
    </option>
  </select>-->

              <ng-select [items]="district"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="distric"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onSelectDistricChange($event,'select')" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['distric'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['distric'].errors && f['distric'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="distric">City<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="city" (change)="onSelectCityChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of cityData" [value]="option.id">
      {{option.text}}
    </option>
  </select>-->

              <ng-select [items]="cityData"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="city"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onSelectCityChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['city'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['city'].errors && f['city'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="distric">Town/Block<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="townblock" (change)="onSelectTownChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of townData" [value]="option.id">
      {{option.text}}
    </option>
  </select>-->

              <ng-select [items]="townData"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="townblock"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onSelectTownChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['townblock'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['townblock'].errors && f['townblock'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>

          </div>
          <div class="row mb-3">

            <div class="col-md-3">
              <label for="village">Village<span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="village" placeholder="enter village" maxlength="100" (blur)="onBlur('village')" (keypress)="onKeyPress($event)" />

              <!-- Validation error messages -->
              <div *ngIf="f['village'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['village'].errors?.['required']">
                  Village name is required.
                </div>
                <div *ngIf="f['village'].errors?.['maxlength']">
                  Village name cannot exceed 100 characters.
                </div>
                <div *ngIf="f['village'].errors?.['pattern']">
                  Village name must only contain letters, with a single space allowed between words.
                </div>
              </div>

            </div>

            <div class="col-md-6">
              <label for=" eventVenueDetails">Event Venue Details<span class="text-danger">*</span></label>
              <textarea class="form-control" formControlName="venueDetails" placeholder="enter event venue" maxlength="500" (blur)="onBlur('venueDetails')"></textarea>

              <!-- Validation error messages -->
              <div *ngIf="f['venueDetails'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['venueDetails'].errors?.['required']">
                  Event venue details is required.
                </div>
                <div *ngIf="f['venueDetails'].errors?.['maxlength']">
                  Event venue details cannot exceed 500 characters.
                </div>
                <div *ngIf="f['venueDetails'].errors?.['pattern']">
                  Event venue details must be proper.
                </div>
              </div>

            </div>

            <div class="col-md-3">
              <label for="eventFocusSector">Event Focus Sector<span class="text-danger">*</span></label>
              <!--<select class="form-control" formControlName="eventFocusSector" (change)="onSelectEventFocusChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of focussector" [value]="option.id">
      {{ option.text }}
    </option>
  </select>-->
              <ng-select [items]="focussector"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="eventFocusSector"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onSelectEventFocusChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['eventFocusSector'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['eventFocusSector'].errors && f['eventFocusSector'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>

          </div>

          <div class="row mb-3">

            <div class="col-md-3">
              <label for="intervention">Intervention<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="intervention">-->
              <!--(change)="onSelectInterventionChange($event,'select')"-->
              <!--<option value="">--select--</option>
    <option *ngFor="let option of intervention" [value]="option.id">
      {{ option.text }}
    </option>
  </select>-->

              <ng-select [items]="intervention"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="intervention"
                         [searchable]="true"
                         placeholder="--select--" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['intervention'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['intervention'].errors && f['intervention'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="typeComponent">Type of Component<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="typeComponent">-->
              <!--(change)="onSelectTypeOfComponentChange($event)"-->
              <!--<option value="">--select--</option>
    <option *ngFor="let option of typeComponent" [value]="option.id">
      {{ option.text }}
    </option>
  </select>-->
              <ng-select [items]="typeComponent"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="typeComponent"
                         [searchable]="true"
                         placeholder="--select--" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['typeComponent'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['typeComponent'].errors && f['typeComponent'].errors['required']">
                  You must select an option.
                </div>
              </div>

            </div>

            <div class="col-md-3">
              <label for="sittingCapacity">Sitting Capacity (Max {{maxSitingCapacity}})<span class="text-danger">*</span></label>
              <input type="number" class="form-control" formControlName="sittingCapacity" placeholder="enter sitting capacity" min="0" [max]="maxSitingCapacity" />

              <!-- Validation error messages -->
              <div *ngIf="f['sittingCapacity'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['sittingCapacity'].errors?.['required']">
                  Sitting capacity is required.
                </div>
                <div *ngIf="f['sittingCapacity'].errors?.['min']">
                  Sitting capacity cannot be less than 0.
                </div>
                <div *ngIf="f['sittingCapacity'].errors?.['max']">
                  Sitting capacity cannot exceed {{ maxSitingCapacity }}.
                  <!--Sitting capacity cannot exceed 50.-->
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
      
      <div class="card mb-3 position-relative">
        <div class="card-header"><h2>Trainer Details</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <!-- Hidden input field part of the Reactive Form -->
            <input type="hidden" formControlName="hiddenValue">
            <div class="col-md-3">
              <label for="trainerName">Anchor/Trainer Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="trainerName" placeholder="Enter anchor/trainer" maxlength="200" (blur)="onBlur('trainerName')" (keypress)="onKeyPress($event)" />

              <!-- Validation error messages -->
              <div *ngIf="f['trainerName'].invalid && (isSubmitted || isAdd)" class="alert alert-danger required">
                <div *ngIf="f['trainerName'].errors?.['required']">
                  Anchor/Trainer name is required.
                </div>
                <div *ngIf="f['trainerName'].errors?.['maxlength']">
                  Anchor/Trainer name cannot exceed 200 characters.
                </div>
                <div *ngIf="f['trainerName'].errors?.['pattern']">
                  Anchor/Trainer name must only contain letters and spaces.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="trainerCompanyName">Anchor/Trainer Company Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="trainerCompanyName" placeholder="Enter anchor/trainer company" maxlength="200" (blur)="onBlur('trainerCompanyName')" (keypress)="onKeyPress($event)" />

              <!-- Validation error messages -->
              <div *ngIf="f['trainerCompanyName'].invalid && (isSubmitted || isAdd)" class="alert alert-danger required">
                <div *ngIf="f['trainerCompanyName'].errors?.['required']">
                  Anchor/Trainer company name is required.
                </div>
                <div *ngIf="f['trainerCompanyName'].errors?.['maxlength']">
                  Anchor/Trainer company name cannot exceed 200 characters.
                </div>
                <div *ngIf="f['trainerCompanyName'].errors?.['pattern']">
                  Anchor/Trainer company name must only contain letters and spaces.
                </div>
              </div>

            </div>

            <div class="col-md-3">
              <label for="contactNumber">Contact Number<span class="text-danger">*</span></label>
              <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="contactNumber" placeholder="Enter contact" maxlength="10" />

              <!-- Validation error messages -->
              <div *ngIf="f['contactNumber'].invalid && (isSubmitted || isAdd)" class="alert alert-danger required">
                <div *ngIf="f['contactNumber'].errors?.['required']">
                  Mobile number is required.
                </div>
                <div *ngIf="f['contactNumber'].errors?.['maxlength']">
                  Mobile number cannot exceed 10 number.
                </div>
                <div *ngIf="f['contactNumber'].errors?.['pattern']">
                  Mobile number must be a valid 10-digit Indian mobile number starting with 7, 8, or 9.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="districtId">District<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="districtId" (change)="onTrainerDistricChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of district" [value]="option.id">
      {{ option.text }}
    </option>
  </select>-->

              <ng-select [items]="district"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="districtId"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onTrainerDistricChange($event)" appendTo="body">
              </ng-select>
            
              <!-- Validation error messages -->
              <div *ngIf="f['districtId'].invalid && (isSubmitted || isAdd)" class="alert alert-danger required">
                <div *ngIf="f['districtId'].errors && f['districtId'].errors['required']">
                  Please select district.
                </div>
              </div>

            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="cityId">City<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="cityId" (change)="onTrainerCityChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of trainerCityData" [value]="option.id">
      {{option.text}}
    </option>
  </select>-->
              <ng-select [items]="trainerCityData"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="cityId"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onTrainerCityChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['cityId'].invalid && (isSubmitted || isAdd)" class="alert alert-danger required">
                <div *ngIf="f['cityId'].errors && f['cityId'].errors['required']">
                  Please select city.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <label for="townId">Town/Block<span class="text-danger">*</span></label>
              <!--<select class="form-select" formControlName="townId" (change)="onTrainerTownChange($event)">
    <option value="">--select--</option>
    <option *ngFor="let option of trainerTownData" [value]="option.id">
      {{option.text}}
    </option>
  </select>-->
              <ng-select [items]="trainerTownData"
                         bindLabel="text"
                         bindValue="id"
                         formControlName="townId"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onTrainerTownChange($event)" appendTo="body">
              </ng-select>

              <!-- Validation error messages -->
              <div *ngIf="f['townId'].invalid && (isSubmitted || isAdd)" class="alert alert-danger required">
                <div *ngIf="f['townId'].errors && f['townId'].errors['required']">
                  Please select town.
                </div>
              </div>

            </div>
            <div class="col-md-3">
              <button *ngIf="showButton" type="submit" class="btn btn-primary btn-sm mt-4" (click)="AddTrainer()"><i class="bi bi-plus-lg"></i> Add</button>
              <button  *ngIf="showCancelButton" type="submit" class="btn btn-danger btn-sm mt-4" (click)="RemoveValidation()">Cncel</button>
            </div>
          </div>
          <div class="row" *ngIf="visibleTable">
            <div class="table-responsive">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Anchor/Trainer Name</th>
                    <th>Anchor/Trainer Company Name</th>
                    <th>Contact Number</th>
                    <th>District</th>
                    <th>City</th>
                    <th>Town/Block</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detail of trainerData; index as i">
                    <td>{{ detail.trainerName }}</td>
                    <td>{{ detail.trainerCompanyName }}</td>
                    <td>{{ detail.contactNumber }}</td>
                    <td>{{ detail.districText }}</td>
                    <td>{{ detail.cityText }}</td>
                    <td>{{ detail.townText }}</td>
                    <td>
                      <div *ngIf="detail.id; else showTrash">
                        <span [ngClass]="{ 'disabled': isDropdownDisabled }" (click)="onEdit(detail.id)" class="btn btn-primary btn-sm mt-1"><i class="bi bi-pencil"></i> Edit</span> 
                        <span [ngClass]="{ 'disabled': isDropdownDisabled }" (click)="onRemove(detail.trainerName)" class="btn btn-danger btn-sm mx-1 mt-1"><i class="bi bi-trash"></i> Delete</span>
                      </div>
                      <ng-template #showTrash>
                        <span [ngClass]="{ 'disabled': isDropdownDisabled }" (click)="onRemove(detail.trainerName)" class="btn btn-danger btn-sm mt-1"><i class="bi bi-trash"></i> Delete</span>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"><h2>SPOC details<span class="text-danger">*</span></h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3">
              <ng-multiselect-dropdown formControlName="spoc"
                                       [placeholder]="'--select--'"
                                       [settings]="dropdownSettings"
                                       [data]="dropdownList"
                                       (onDeSelect)="onSOCDeSelect($event)"
                                       (onSelect)="onSOCSelect($event)"
                                       [ngClass]="{ 'disabled-dropdown': isDropdownDisabled }">
              </ng-multiselect-dropdown>
              <div *ngIf="f['spoc'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['spoc'].errors && f['spoc'].errors['required']">
                  Spoc is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover" *ngIf="visibleSPOCTable">
                  <thead>
                    <tr>
                      <th>Person Name</th>
                      <th>Mobile Number</th>
                      <th>Email Id</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let detail of spocData; index as i">
                      <td>{{ detail.PersonName }}</td>
                      <td>{{ detail.MobileNumber }}</td>
                      <td>{{ detail.EmailId }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div *ngIf="this.txtButton=='Update'" class="row mb-3">
            <!--<div *ngIf="showButton" class="col-md-4">
              <label for="status">Type of Status<span class="text-danger">*</span></label>

              <select class="form-select" formControlName="status" (change)="onStatusChange()">
                <option *ngFor="let option of filteredOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>

              <div *ngIf="f['status'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['status'].errors && f['status'].errors['required']">
                  type of status is required.
                </div>
              </div>


            </div>-->
            <div class="col-md-12" *ngIf="showButton">
              <label for=" remarks">Remarks<span class="text-danger" [hidden]="!isRemarksRequired">*</span></label>
              <textarea class="form-control" formControlName="remarks" placeholder="Enter remarks" rows="4" cols="80" maxlength="200"></textarea>

              <div *ngIf="f['remarks'].invalid && isSubmitted" class="alert alert-danger required">
                <div *ngIf="f['remarks'].errors && f['remarks'].errors['required']">
                  Remarks are required when status is "Re-Schedule" or "Cancel".
                </div>
              </div>

            </div>
          </div>
          <div class="row text-center">
            <div class="col-md-12">
              <button *ngIf="showButton" type="submit" class="btn btn-success" (click)="onSubmit()">{{txtButton}}</button>
              <!--<button type="submit" class="btn btn-success" (click)="onSubmit()">{{txtButton}}</button>-->
              <button type="button" class="btn btn-info" (click)="onBack()">Back</button>
            </div>
          </div>
        </div>
      </div>
     
    </form>
  </div>
</div>

